define(function() {
  var IpsModelCollection = require('civicsBase/ipsModelCollection');
  const favorite_instrument_type_model = require('civicsModels/portal/favorite_instrument_type_model');

  return IpsModelCollection.extend({
    model: favorite_instrument_type_model,
    urlRoot: '/delegate/civics-api/api/portal/favorites/cdr/instrumenttypes',
    url: function() {
      return this.urlRoot;
    }
  });
});
